import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { RootState } from "./reducers/persistedReducer";
import api from '../lib/app-api';
import { PersistedState, DEFAULT_VERSION } from 'redux-persist';

export interface ApiError {
  errorCode: string | null,
  developerMessage: string | null,
  userMessage: string | null,
  moreInfo: string | null,
}

export interface apiStatusStateType {
  lastError: number | null,
  errorCode: string | null,
  developerMessage: string | null,
  userMessage: string | null,
  moreInfo: string | null,
  lastFetch: number | null,
  loading: boolean
}

export const apiStatusInitialState: apiStatusStateType = {
  lastError: null,
  errorCode: null,
  developerMessage: "",
  userMessage: "",
  moreInfo: "",
  lastFetch: null,
  loading: false
}

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  typeof api,
  Action<string>
>

export const persistMigrations = {
  1: (state: any) => {
    return undefined
  }
}

export default function createNullMigrate(
  config?: { debug: boolean }
) {
  let { debug } = config || {}
  return function(
    state: PersistedState,
    currentVersion: number
  ): Promise<PersistedState> {
    if (!state) {
      if (process.env.NODE_ENV !== 'production' && debug)
        console.log('redux-persist: no inbound state, skipping migration')
      return Promise.resolve(undefined)
    }

    let inboundVersion: number =
      state._persist && state._persist.version !== undefined
        ? state._persist.version
        : DEFAULT_VERSION
    if (inboundVersion === currentVersion) {
      if (process.env.NODE_ENV !== 'production' && debug)
        console.log('redux-persist: versions match, noop migration')
      return Promise.resolve(state)
    }
    if (inboundVersion > currentVersion) {
      if (process.env.NODE_ENV !== 'production')
        console.error('redux-persist: downgrading version is not supported')
      return Promise.resolve(state)
    }

    if (process.env.NODE_ENV !== 'production' && debug)
      console.log('redux-persist: new version detected, blowing up state')

      return Promise.resolve(undefined)
  }
}